export function query<Selector extends string, T extends Element>(
  selector: Selector,
  parentElement: HTMLElement | Document = document,
): ElementsQueriedBy<Selector, T> {
  const nodeList: NodeListOf<T> = parentElement.querySelectorAll<T>(selector);

  return Array.prototype.slice.call(nodeList);
}

type ElementsQueriedBy<
  S extends string,
  T extends Element,
> = S extends keyof HTMLElementTagNameMap ? HTMLElementTagNameMap[S][] : T[];
